import React, { useState } from 'react'

import { Loader } from '@fourthwall/components'

import * as S from './Guide.styled'

type GuideProps = {
  active?: boolean
  shouldLoad?: boolean
  url: string
  onLoad?: () => void
}

export const Guide = ({ active = false, shouldLoad, url, onLoad }: GuideProps) => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <S.Container active={active}>
      {isLoading && (
        <S.LoaderWrapper>
          <Loader size="medium" />
        </S.LoaderWrapper>
      )}
      <iframe
        src={shouldLoad ? url : undefined}
        loading={active ? 'eager' : 'lazy'}
        width="100%"
        height="100%"
        onLoad={() => {
          setIsLoading(false)
          onLoad?.()
        }}
      />
    </S.Container>
  )
}
